module.exports = __webpack_public_path__ + "img/67_18.9126887c.png";